import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('GasStationBill-index-1992f2b82b079b501-1'),
    routerUrl: '/GasStationBill',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./GasStationBill')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('GasStationBill-index-1992f2b82b079b501-2'),
        routerUrl: '/GasStationBillForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./GasStationBillForm')),
      },
      //$MORE$
    ],
  },
];
